export default "__VITE_ASSET__qynK2WGA__"